import { Injector, Component, ViewEncapsulation, Inject, OnInit } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DOCUMENT } from '@angular/common';
import { DropdownServicesServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
    templateUrl: './default-brand.component.html',
    selector: 'default-brand',
    encapsulation: ViewEncapsulation.None
})
export class DefaultBrandComponent extends AppComponentBase implements OnInit {

    defaultLogo = AppConsts.appBaseUrl + '/assets/common/images/perfetto-logo1.png';
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    tenancyLogo: string;
    tenantName = '';

    constructor(
        injector: Injector,
        @Inject(DOCUMENT) private document: Document,
        private _dropdownServiceProxy: DropdownServicesServiceProxy
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.tenantName = this.appSession.tenant ? this.appSession.tenant.name : '';
        this._dropdownServiceProxy.getBranchLogo().subscribe(result => {
            if (result) {
                this.tenancyLogo = AppConsts.ftpUrl + '/logoImage/' + result;
            }
        });
    }

    toggleLeftAside(): void {
        this.document.body.classList.toggle('kt-aside--minimize');
    }
}
